module.exports = __webpack_public_path__ + "static/gallery-img-24-92e4e3ed6163dea61261fe759428f477.jpg";